<template>
  <div>
    <section
      v-if="!showGuia"
      class="columns is-fullheight is-fullwidth"
      style="transition: all 0.3s ease 0s !important;"
    >
      <div
        class="container column "
        style="transition: all 0.3s ease 0s !important;"
      >
        <transition name="fade">
          <div class="container">
            <div class="section" v-if="this.proceso" id="cont">
              <!--  Header  -->
              <section id="views" class="hero is-light">
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title" v-if="proceso">
                      {{ proceso.cliente.nombre }}
                    </h1>
                    <h2 class="subtitle" v-if="proceso.nombre">
                      Resumen del Resultado de CL7 - Clima Laboral -
                      {{ proceso.nombre }}
                    </h2>
                  </div>
                </div>
              </section>

              <!--  Data  -->
              <div class="columns fecha">
                <div class="column">
                  <span>Fecha de diagnóstico</span>
                  <h4 class="has-text-dark">
                    {{ dateProcess(infoProcess.date) }}
                  </h4>
                </div>
                <div class="column">
                  <table class="is-flex" style="width: 100%">
                    <tr
                      class="bg-muyinconveniente"
                      v-tooltip.bottom="
                        'Menos del 16% de las personas en alto o muy alto'
                      "
                    >
                      <td class="p-2">Muy Inconveniente</td>
                    </tr>
                    <tr
                      class="bg-inconveniente"
                      v-tooltip.bottom="
                        'Entre el 16% y el 29.9% de personas en alto o muy alto'
                      "
                    >
                      <td class="p-2">Inconveniente</td>
                    </tr>
                    <tr
                      class="bg-regular"
                      v-tooltip.bottom="
                        'Entre el 30% y el 69.9% de personas en alto o muy alto'
                      "
                    >
                      <td class="p-2">Regular</td>
                    </tr>
                    <tr
                      class="bg-positivo"
                      v-tooltip.bottom="
                        'Entre el 70% y el 83.9% de personas en alto o muy alto'
                      "
                    >
                      <td class="p-2">Positivo</td>
                    </tr>
                    <tr
                      class="bg-excelente"
                      v-tooltip.bottom.left="
                        'Si el 84% o más de las personas está en los niveles de alto y muy alto'
                      "
                    >
                      <td class="p-2">Excelente</td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- SubHeader - Cards Info  -->
              <section style="margin-top: 30px">
                <div class="container columns has-text-centered">
                  <div class="column is-parent is-vertical">
                    <div class="box">
                      <h1 class="is-size-5 has-text-weight-bold">
                        Participación
                      </h1>
                      <span class="is-size-3 has-text-dark"
                        >{{ infoProcess.participation }}%</span
                      >
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 sub has-text-weight-bold">
                        Encuestados
                      </h1>
                      <span class="is-size-4">{{
                        infoProcess.totalParti
                      }}</span>
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 sub has-text-weight-bold">
                        Encuestas válidas
                      </h1>
                      <span class="is-size-4">{{
                        infoProcess.totalPartiEli
                      }}</span>
                    </div>
                  </div>
                  <div class="column is-parent is-vertical">
                    <div class="box box-sub">
                      <h1 class="is-size-5 sub has-text-weight-bold">
                        Eliminados
                      </h1>
                      <span class="is-size-4">{{
                        infoProcess.inconsistencies
                      }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <!--  Section Views  -->
              <div id="views">
                <ResultadosDetallado
                  :summaryTotal="summary"
                  :proceso="proceso"
                  :processValuesCal="processValuesCal"
                  @goToGuie="goToGuie"
                  style="margin-top: 40px"
                ></ResultadosDetallado>
              </div>
            </div>
            <div v-if="!proceso" class="has-text-centered">
              <h1 class="is-size-1" style="vertical-align: middle">
                404 Página no encontrada
              </h1>
            </div>
          </div>
        </transition>
      </div>
      <div
        :class="showMenu ? 'column is-2' : 'column is-0'"
        style="transition: all 0.3s ease 0s !important;"
      >
        <aside
          :class="showMenu ? 'sidebarClima-show' : 'sidebarClima-none'"
          class="is-narrow-mobile is-fullheight section is-hidden-mobile scroll-light"
          style="overflow-y: scroll"
        >
          <p
            class="has-text-centered is-size-4 has-text-weight-bold has-text-dark"
          >
            Interpretaciones
          </p>
          <div v-for="(item, k) in calificaciones" :key="k">
            <transition name="fade">
              <div v-if="sectInter === '' || sectInter === item.title">
                <br />
                <div
                  class="tags has-addons"
                  style="cursor: pointer"
                  v-on:click="selectVar(item.title)"
                >
                  <span
                    class="tag is-medium is-dark is-flex"
                    style="width: 100%; justify-content: space-between"
                  >
                    <span></span>
                    <span>{{ item.title }}</span>
                    <span class="icon"
                      ><i class="material-icons is-size-1"
                        >arrow_drop_down</i
                      ></span
                    >
                  </span>
                </div>
                <div class="text-justify is-size-7">{{ item.def }}</div>
              </div>
            </transition>
            <transition name="fade">
              <div v-if="sectInter === item.title">
                <div v-for="(itVar, kv) in item.dimensiones" :key="kv">
                  <hr />
                  <div class="tags has-addons">
                    <span class="tag is-medium" style="width: 100%">
                      {{ itVar.title }}
                    </span>
                  </div>
                  <div class="text-justify is-size-7">{{ itVar.inter }}</div>
                </div>
                <br />
              </div>
            </transition>
          </div>
        </aside>
      </div>
    </section>
    <GuiaInterpretacion
      v-if="showGuia"
      :proceso="proceso"
      @selectSection="goToGuie"
    ></GuiaInterpretacion>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import ResultadosDetallado from "./ResultadosDetallado.vue";
import GuiaInterpretacion from "./GuiaInterpretacion.vue";
import { mapState } from "vuex";
import json from "./interpretaciones.json";
/* import {gsap} from "gsap"; */

export default {
  data() {
    return {
      summary: {},
      proceso: {},
      infoProcess: {},
      selected: {
        filters: {},
      },
      showGuia: true,
      showMenu: false,
      calificaciones: json,
      sectInter: "",
    };
  },
  computed: {
    ...mapState(["tokenUser", "empresa", "windowwidth", "isOculto"]),
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    // Data
    async getData() {
      try {
        if (this.$route.params.id && this.$route.params.filter) {
          // Set Filters
          let allFilters = atob(atob(this.$route.params.filter));
          this.selected.filters = JSON.parse(allFilters);

          await this.getProcess(this.$route.params.id);
          await this.findSummary();
        }
      } catch (e) {
        await this.$store.dispatch("notify", {
          message: `Error al cargar el tablero compartido`,
          type: "is-danger",
        });
      }
    },
    async findSummary() {
      try {
        const query = {
          filters: this.selected.filters,
          proceso: this.proceso._id,
          empresa: this.proceso.cliente._id,
        };
        const result = await apiServices.post(`/traecalculoclimaview`, query);
        if (result.data) {
          if (this.proceso.comparison) {
            query.proceso = this.proceso.comparison._id;
            const resultComp = await apiServices.post(
              `/traecalculoclimaview`,
              query
            );
            result.data.calculos.processComp = this.processValuesCal(
              resultComp.data.calculos
            );
            result.data.calculos.processComp.nombre = this.proceso.comparison.nombre;
          }
          this.infoProcess = result.data.infoProcess;
          this.summary = this.processValuesCal(result.data.calculos);
          if (Object.keys(this.selected.filters).length) {
            this.summary.infoProcess = result.data.infoProcess;
            this.summary.filters = this.selected.filters;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getProcess(idProcess) {
      const result = await apiServices.get(`cohorteClima/${idProcess}`);
      if (result.data) {
        this.proceso = result.data;
      }
    },
    // Others
    processValuesCal(summary) {
      const labelsinicial = Object.keys(summary.total);
      for (let index in labelsinicial) {
        const label = labelsinicial[index];
        summary.total[label].p =
          ((summary.total[label].Alto + summary.total[label]["Muy alto"]) /
            (summary.total[label].Alto +
              summary.total[label]["Muy alto"] +
              summary.total[label].Medio +
              summary.total[label].Bajo +
              summary.total[label]["Muy bajo"])) *
          100;
        summary.total[label].n1 =
          summary.total[label].Alto +
          summary.total[label]["Muy alto"] +
          summary.total[label].Medio +
          summary.total[label].Bajo +
          summary.total[label]["Muy bajo"];
      }
      return summary;
    },
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        el.scrollIntoView({ behavior: "smooth" });
      });
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
    goToGuie() {
      this.showGuia ? (this.showGuia = false) : (this.showGuia = true);
      this.autoScroll();
    },
    changeMenu() {
      this.showMenu ? (this.showMenu = false) : (this.showMenu = true);
    },
    selectVar(group) {
      if (this.sectInter === group) {
        this.sectInter = "";
      } else {
        this.sectInter = group;
      }
    },
  },
  created() {},
  watch: {
    isOculto(nv) {
      if (nv) {
        this.showMenu = false;
      }
    },
  },
  components: {
    ResultadosDetallado,
    GuiaInterpretacion,
  },
};
</script>

<style lang="scss">
.sidebarClima-show {
  z-index: 50;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: 0;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.sidebarClima-none {
  z-index: 0;
  background: white;
  position: fixed;
  height: 100%;
  width: 256px;
  right: -300px;
  top: 0;
  transition: all 0.3s ease 0s;
  box-shadow: 48px -6px 46px 29px black;
}

.button-inter-closed {
  display: none;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-Clima-closed {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 97%;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.button-Clima-open {
  position: fixed;
  top: 20px;
  padding: 15px;
  margin-left: 79% !important;
  transition: all 0.3s ease 0s;
  z-index: 61;
}

.is-mobileClima {
  @media (max-width: 769px) {
    display: none !important;
  }
}

.fecha {
  margin-top: 10px;
  margin-left: 2px;
}

.bg-excelente {
  background-color: #76be7c !important;
  color: white;
}

.bg-positivo {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-regular {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-inconveniente {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-muyinconveniente {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.p-2 {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.fecha table {
  justify-content: end;
}

.box-sub {
  height: 118px !important;
}

.sub {
  margin-bottom: 6px !important;
}

/* Backgrounds */

.rango1 {
  background-color: #76be7c !important;
  color: white;
}

.rango2 {
  background-color: #d9ead3 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: #fde8af !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: #f5bc95 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: #fda0a0 !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/climan/ViewClima.vue